import { z } from 'zod';

// PASSTHROUGH: fornitore esterno (ElevenLabs Convai) aggiunge campi senza preavviso
// (nuove versioni dell'event payload, dynamic_variables, conversation_config).
// MAI usare .strict() qui.
export const elevenlabsPostCallWebhookSchema = z.object({
  type: z.string().optional(),
  event_timestamp: z.number().optional(),
  agent_id: z.string().optional(),
  data: z.object({
    agent_id: z.string().optional(),
    conversation_id: z.string().optional(),
  }).passthrough().optional(),
}).passthrough();

export const elevenlabsConversationInitWebhookSchema = z.object({
  agent_id: z.string().optional(),
  caller_id: z.string().optional(),
  from: z.string().optional(),
  called_number: z.string().optional(),
  to: z.string().optional(),
  conversation_id: z.string().optional(),
  data: z.object({
    agent_id: z.string().optional(),
    caller_id: z.string().optional(),
    called_number: z.string().optional(),
  }).passthrough().optional(),
}).passthrough();

export const elevenlabsToolCallParamsSchema = z.object({
  tenantId: z.string().uuid('ID tenant non valido'),
  agentDbId: z.string().uuid('ID agente non valido'),
  toolName: z.string().min(1).max(200),
});

export const elevenlabsToolCallBodySchema = z.object({}).passthrough();
